"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadWorldNPCUpdate = void 0;
const NPC_1 = require("../../classes/NPC");
const definables_1 = require("definables");
const loadWorldNPCUpdate = (worldNPCUpdate) => {
    const npc = (0, definables_1.getDefinable)(NPC_1.NPC, worldNPCUpdate.npcID);
    npc.direction = worldNPCUpdate.direction;
};
exports.loadWorldNPCUpdate = loadWorldNPCUpdate;
